import axios from '@/utils/api'

const actions = {
  async findByCaixa ({ commit }, caixa) {
    return axios({
      url: `status/findByCaixa/${caixa}`,
      method: 'GET'
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/status.js